import api from './authService';
import type {
  WebhookMapping,
  WebhookMappingCreate,
  WebhookMappingUpdate,
  WebhookMappingListResponse
} from '@types';

// Webhookマッピング一覧取得
export const getWebhookMappings = async (
  provider?: string
): Promise<WebhookMappingListResponse> => {
  const params = new URLSearchParams();
  if (provider) params.append('provider', provider);

  const url = params.toString()
    ? `/admin/webhook-mappings?${params.toString()}`
    : '/admin/webhook-mappings';

  const response = await api.get<WebhookMappingListResponse>(url);
  return response.data;
};

// Webhookマッピング詳細取得
export const getWebhookMapping = async (id: number): Promise<WebhookMapping> => {
  const response = await api.get<WebhookMapping>(`/admin/webhook-mappings/${id}`);
  return response.data;
};

// Webhookマッピング作成
export const createWebhookMapping = async (data: WebhookMappingCreate): Promise<WebhookMapping> => {
  const response = await api.post<WebhookMapping>('/admin/webhook-mappings', data);
  return response.data;
};

// Webhookマッピング更新
export const updateWebhookMapping = async (
  id: number,
  data: WebhookMappingUpdate
): Promise<WebhookMapping> => {
  const response = await api.patch<WebhookMapping>(`/admin/webhook-mappings/${id}`, data);
  return response.data;
};

// Webhookマッピング削除
export const deleteWebhookMapping = async (id: number): Promise<void> => {
  await api.delete(`/admin/webhook-mappings/${id}`);
};
